<section class="bg-half-260 bg-primary d-table w-100" id="home"
         style="background-size:cover; background-image:url('assets/3r/cover/students-1807505_640.jpg');">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-heading text-center mt-4">
                    <h1 class="display-4 title-dark font-weight-bold text-white mb-3">VISA AND FINANCIAL ASSISTANCE</h1>
                    <!--                    <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>-->
                    <!--                    <div class="mt-4 pt-2">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-primary"><i class="mdi mdi-email"></i> Get-->
                    <!--                            Started</a>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

</section>

<div class="container mt-100 mt-60 mb-5">
    <div class="row ">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h3 class="title mb-4 mt">VISA ASSISTANCE</h3>
                <p class="text-muted   mb-0">
                    Applying for visa is one of the most critical aspects of your preparations for overseas studies. The
                    visa, however, can also be one of the most daunting aspects of the preparations. It is one aspect
                    with which you will seek guidance.
                    <br>
                    <br>
                    3R International has excellent relationships with Embassies and High Commissions worldwide and is
                    able to offer you accurate study abroad student visa information and a seamless experience in
                    applying for visas to study overseas.
                    <br>
                    <br>
                    Our team of experienced study abroad visa consultants has expertise across all countries and is able
                    to guide you through the complex maze of preparing and submitting your visa application.
                    <br>
                    <br>
                    With the help of our knowledgeable visa consultants, you can be sure that you fulfill all the
                    necessary visa conditions and requirements with ease. Our counsellors will also carefully review the
                    documents and check if everything is in order before submitting them.
                    <br>
                    <br>
                    Our professional consultants will also provide you with an important checklist and help you prepare
                    for visa interviews, if needed. 3R International Consultants make the complicated process of
                    applying for student visas very simple and easy. Experts know exactly how to guide students
                    throughout the study abroad student visa process.
                    <br>
                    <br>
                    US Visa – F-1 visa is the academic student visa that allows students to study at any of the
                    accredited universities and colleges in US. After receipt of I-20, which confirms that the student
                    is accepted into the university, he or she has to pay the visa fee and SEVIS fee before booking the
                    visa appointment by completing the visa application form.
                    <br>
                    <br>
                    If you are applying for a UK visa, our experienced counsellors will offer guidance and advice
                    through the process. In order to obtain UK visa, you must qualify for the Tier 4 points-based
                    system. You must have at least 40 points to get a student UK visa.
                    <br>
                    <br>
                    For Australian student visas, our knowledgeable counsellors will help you identify the type of visa
                    you need to apply for based on the course you are planning to undertake. Australian student visas
                    must be applied for 12 weeks before the orientation at the institute.
                    <br>
                    <br>
                    For Study Permit, Canadian visa requires you to submit several documents that includes the
                    unconditional acceptance letter, passport size photographs, passport, fees receipt, academic
                    documents, financial documents, all relevant correspondence with the university, scholarship letter
                    if any, medical reports, work experience details and test scores. Apart from offering the right
                    Canadian visa advice, expert counsellors at 3R International will also review your documents.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">FINANCIAL ASSISTANCE</h5>
                <p class="text-muted   mb-0">
                    3R International has excellent relationships with financial companies in Sri Lanka and is able to
                    offer you best financial support to study overseas.
                    <br>
                    <br>
                    You can benefit from our comprehensive package of advice designed to ensure that you are fully
                    prepared, taking advantage of our guidance on collecting relevant documentation. This also includes
                    all important financial aspects and assistance with the key aspects of any interview that you may
                    have with the High Commission or Embassy. With 3R International, you can be assured that you will
                    address all relevant study abroad visa requirements successfully.
                    <br>
                    <br>
                    At 3R International, we are here to help you apply for your visa with minimal hassle and stress.
                    <br>
                    <br>
                    Contact 3R International right now for a complete study abroad student visa information and
                    guidance.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>


</div>
